// useEventsSearch.ts

import { useState, useEffect } from 'react';
import { searchEvents } from '../functionApi';
import { useAxiosInterceptor } from '../wrappers';
import { EventSearchPayload } from '../apiTypes';

export const useEventsSearch = (
  payload: EventSearchPayload,
  skip = 0,
  limit = 100
) => {
  useAxiosInterceptor();

  const [events, setEvents] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadEvents = async () => {
      setLoading(true);
      try {
        const data = await searchEvents(payload);
        setEvents(data);
        setError(null);
      } catch (err) {
        console.error(err);
        setError('Errore nel caricamento degli eventi');
      } finally {
        setLoading(false);
      }
    };

    loadEvents();
  }, [payload]);

  return { events, loading, error };
};
